import React, { useState, useEffect, useContext } from 'react'
import { AppContext } from '../../../../App'
import { Link, useLocation } from 'react-router-dom'
import { format } from 'date-fns'
import ChoiceDayHoursClient from '../../../../components.js/serveur/clients/ChoiceDayHoursClient'
import ChoiceServiceClient from '../../../../components.js/serveur/clients/ChoiceServiceClient'
import ChoiceStaffClient from '../../../../components.js/serveur/clients/ChoiceStaffClient'
import useFirebase from '../../../../firebase/useFirebase'
import useClients from '../../../../hooks/serveur/clients/useClients'
import ModalChoiceStaffUsers from './../../../../components.js/users/homeUsers/ModalChoiceStaffUsers'
import useClientBooking from './../../../../hooks/serveur/clients/useClientBooking'
import HeaderReturn from './../../../../components.js/serveur/siteWeb/HeaderReturn'
import HeaderReturnBooking from '../../../../components.js/serveur/clients/HeaderReturnBooking'
import useClientPlanning from './../../../../hooks/serveur/clients/useClientPlanning'
import usePush from '../../../../hooks/usePush'
import usePlanning from '../../../../hooks/usePlanning'
import ChoiceStaffPlanning from './../../../../components.js/serveur/planning/ChoiceStaffPlanning' 
import PlanningServeurClient from '../../../../components.js/serveur/clients/PlanningServeurClient'
import useForm from '../../../../hooks/useForm'
import ModalListDays from '../../../../components.js/serveur/planning/ModalListDays'
import ModalAddBookingServeurClient from '../../../../components.js/serveur/clients/ModalAddBookingServeurClient'
import ModalConfirm from '../../../../components.js/modal/ModalConfirm'

const INITIAL_STATE = {
    idService:'',
    nameService:'',
    priceService:'',
    durationService:'', 
    idStaff:'',
    surnameStaff:'', 
    nameStaff:'', 
    surname:'',
    name:'',
    email:'',
    password:'', 
    hours:'',
}

const ClientBooking = () => {
    const { user } = useContext(AppContext)
    const location = useLocation()
    const { state } = location
    const [montage, setMontage] = useState(true)
    const { updateData, readData, writeData, deleteData, profil, services, staff, clients, booking, datesOff, count } = useFirebase()
    const [prestation, setPrestation] = useState(false)
    const { 
        _displayHours, 
        _display60Days, 
        _converteTimeToHours, 
        _converteTimeToSingleHour,
        _converteTimeMinutes,
        _convertHoursToTime,   
        _choiceStaff, 
        _deleteState,  
        _compareDay,  
        _compareHours, 
        _compareCurrentDayHours, 
        _compareBooking, 
        valuesPlanning  
    } = usePlanning(INITIAL_STATE) 
    const { _choiceService, valuesService, /*_deleteState, _choiceStaff,*/ _updateHours, _choiceHours } = useClientBooking(INITIAL_STATE)
    const { /*_converteTimeToHours, _displayHours, _display60Days, */ _displayStaff } = useClientPlanning(valuesService)
    const { values, setValues, handleChange, refresh } = useForm(INITIAL_STATE) 
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const { _sendPushClientBooking } = usePush()
    const [choiceService, setChoiceService] = useState([])
    const [dataBooking, setDataBooking] = useState([])
    const [choiceDay, setChoiceDay] = useState()

    useEffect(() => {
        readData(user.uid) 
        const date = format(new Date(), 'MM/dd/yyyy')
        setChoiceDay(date)
    },[montage])

    const _handleAddBooking = (date,dateInt,dateShow,hours,idStaff,surnameStaff,nameStaff) => {
        const duration = parseInt(choiceService.durationService)
        const dur = duration / 15
        for (let i = 0; i < dur ; i++) {
            const data = { 
                date:date, 
                dateShow:dateShow, 
                hours:hours, 
                surnameClient:state.surnameClient, 
                nameClient:state.nameClient,
                emailClient:state.emailClient,
                uidClient:state.uidClient,
                idStaff:idStaff,
                surnameStaff:surnameStaff,
                nameStaff:nameStaff,
                idService:choiceService.idService,
                nameService:choiceService.nameService,
                priceService:choiceService.priceService,
                durationService:choiceService.durationService,
                occurence:i,
                idStandard:dateInt+idStaff
            }
            const h = hours+i
            // console.log('ClientBooking _handleAddBooking ', state.surnameClient, state.nameClient,/* state.emailClient,*/ state.uidClient, state.emailClient)
            updateData('entreprises/'+user.uid+'/booking/'+dateInt+idStaff+h,data)
        }
        refresh()
        setChoiceService([])
    }
 
    // DELETE BOOKING 
    const _handleDeleteBooking = () => {
        // console.log('Planning _handleDeleteBooking ', dataBooking.idStandard, dataBooking.hours, dataBooking.duration) 
        const duration = parseInt(dataBooking.duration)
        const dur = duration / 15
        console.log('Planning _handleDeleteBooking ', dataBooking.idStandard+dur)
        for (let i = 0; i < dur; i++) {
            const h = dataBooking.hours+i
            deleteData('entreprises/'+user.uid+'/booking/'+dataBooking.idStandard+h)
        }
        // deleteData('entreprises/'+user.uid+'/booking/'+dataBooking.id)
        refresh()
        setDataBooking([])
        setChoiceService([])
    }

    // REFRESH MODAL
    const _refreshModal = () => {
        console.log('Planning _refreshModal ', values.name)
        refresh()
        setChoiceService([])
    }

    return (
        <div className='container-fluid'>

            {/* HEADER RETURN */}
            {clients.filter(c => c.uid === state.uidClient).map(c => (
                <div key={c.id}>
                    <HeaderReturnBooking 
                        title={c.surname+'  '+c.name}
                        state={state}
                    />
                </div>
            ))} 

            {/* CHOISIR UN STAFF POUR LE PLANNING */} 
            <ChoiceStaffPlanning 
                valuesPlanning={valuesPlanning} 
                _deleteState={_deleteState}
                staff={staff}
                _choiceStaff={_choiceStaff}
            /> 

            {/* PLANNING */}
            <PlanningServeurClient
                _displayHours={_displayHours}
                _converteTimeToHours={_converteTimeToHours}
                _converteTimeToSingleHour={_converteTimeToSingleHour}
                _converteTimeMinutes={_converteTimeMinutes}
                _convertHoursToTime={_convertHoursToTime}
                _display60Days={_display60Days}
                booking={booking}
                staff={staff}
                datesOff={datesOff}
                services={services}
                valuesPlanning={valuesPlanning}
                setDataBooking={setDataBooking}
                _compareDay={_compareDay}
                _compareHours={_compareHours}
                _compareCurrentDayHours={_compareCurrentDayHours}
                _compareBooking={_compareBooking}
                user={user}
                values={values}
                choiceService={choiceService}
                choiceDay={choiceDay}
            />

            {/* MODAL CHOICE DAYS */}
            <ModalListDays 
                setChoiceDay={setChoiceDay} 
                staff={staff}
                _display60Days={_display60Days}
            /> 

            <ModalAddBookingServeurClient
                dataBooking={dataBooking}
                _converteTimeToHours={_converteTimeToHours}
                setValues={setValues}
                _handleAddBooking={_handleAddBooking}
                services={services}
                choiceService={choiceService}
                setChoiceService={setChoiceService}
                _refreshModal={_refreshModal}
            />

            {/* MODAL CONFIRM DELETE */}
            <ModalConfirm 
                title='Êtes vous sûr de vouloir supprimer la réservation ?'
                _handleModal={_handleDeleteBooking}
            />

        </div>
    )
}

export default ClientBooking


